<div class="controls">
  @if (page()) {
    <label i18n-title title="pages: {{ page()!.page.totalPages }}, results: {{ page()!.page.totalElements }}" i18n>more results: </label>
    @if (hasQuery()) {
      <a class="first-page"
         routerLink="./"
         [class.disabled]="page()!.page.number === 0"
         [queryParams]="{ pageNumber: store.view.defaultPageNumber() ? 0 : null }"
         queryParamsHandling="merge" i18n>first</a>
      <span> | </span>
      @if (showPrev()) {
        <a class="prev-page"
           routerLink="./"
           routerLinkActive="disabled"
           [queryParams]="{ pageNumber: prev() }"
           (click)="cursorPage(prev(), $event)"
           queryParamsHandling="merge" i18n>prev</a>
        <span> | </span>
      }
    }
    <a class="next-page"
       routerLink="./"
       [class.disabled]="page()!.page.number === page()!.page.totalPages - 1"
       [queryParams]="{ pageNumber: next() }"
       (click)="cursorPage(next(), $event); scrollUp()"
       queryParamsHandling="merge" i18n>next</a>
    <span> | </span>
    @if (showPageLast()) {
      <a class="last-page"
         routerLink="./"
         [class.disabled]="page()!.page.number === page()!.page.totalPages - 1"
         [queryParams]="{ pageNumber: last() }"
         queryParamsHandling="merge" i18n>last</a>
    }
  }

  <label for="pageSize" i18n> size: </label>
  <select id="pageSize" [ngModel]="pageSize()" (ngModelChange)="setPageSize($event)">
    @if (outOfPageSizeRange(store.view.pageSize())) {
      <option [value]="store.view.pageSize()">{{ store.view.pageSize() }}</option>
    }
    @for (size of pageSizes; track size) {
      <option [value]="size">{{ size }}</option>
    }
  </select>

  @if (!hideCols() && (cols() || colsChanged())) {
    <label for="cols" i18n> cols: </label>
    <select id="cols" [ngModel]="cols()" (ngModelChange)="setCols($event)">
      <option [value]="0" i18n>default</option>
      @if (outOfColSizeRange(store.view.cols() || 1)) {
        <option [value]="store.view.cols()">{{ store.view.cols() }}</option>
      }
      @for (size of colSizes; track size) {
        <option [value]="size">{{ size }}</option>
      }
    </select>
  }
</div>
@if (page()) {
  <div class="print-view" i18n>
    Page {{ page()!.page.number + 1 }} of {{ page()!.page.totalPages }} (size: {{ page()!.page.size }})
  </div>
}
